import { FEATURE_PREFIX } from '../constants/featurePrefix'
import { FEATURE_PREFIX_SEPARATOR } from '../constants/featurePrefixSeparator'
import { OrganizationFeatureFlag } from '../enums/organizationFeatureFlag'

export const getOrganizationFeatureFlagKey = (featureFlag: OrganizationFeatureFlag): string =>
  `${FEATURE_PREFIX}${FEATURE_PREFIX_SEPARATOR}${featureFlag}`
